import { Injectable } from '@angular/core';
import {BaseService} from '../shared/base-service/base-service.service';
import {Observable} from 'rxjs';
import {UrlConstant} from '../shared/constants/url.class';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService extends BaseService {
  getWarehouses(): Observable<any[]> {
    return this.get('/WareHouses');
  }
  getWarehouseById(id): Observable<any> {
    return this.get(`/WareHouses/${id}`);
  }
  addWarehouse(item: any): any {
    return this.post('/WareHouses', item);
  }
  addUserWareHouse(item: any): any {
    return this.post('/WareHouses/AddUserWareHouse', item);
  }
  removeUserWareHouse(item: any): any {
    return this.post('/WareHouses/RemoveUserWareHouse', item);
  }

  updateWarehouse(item: any): any {
    return this.put(`/WareHouses/${item.id}`, item);
  }
  deleteWarehouse(id: any): any {
    return this.delete(`/WareHouses/${id}`, null);
  }
  getWarehousesByUserId(userId: any): Observable<any[]> {
    return this.get(`/WareHouses/GetWareHouseByUser/${userId}`);
  }
  processShortage(item: any): any {
    return this.post('/WarehouseInventory/ProcessShortage', item);
  }
}
